import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [logoError, setLogoError] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            {!logoError ? (
              <>
                <img
                  src="/logo.png"
                  alt="Logo"
                  className="h-14 w-auto"
                  onError={() => setLogoError(true)}
                />
                <h6 className="text-lg font-bold text-gray-800 pl-5 pt-2 hidden md:flex">E-Visa Application Portal</h6>
              </>
            ) : (
              <span className="text-xl font-bold text-indigo-600">
                Visa Portal
              </span>
            )}
          </Link>

          {/* Navigation Links */}
          <nav className="flex items-center space-x-6">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'text-indigo-600 bg-indigo-50'
                  : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50'
              }`}
            >
              Home
            </Link>
            <Link
              to="/check-status"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/check-status'
                  ? 'text-indigo-600 bg-indigo-50'
                  : 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50'
              }`}
            >
              Check Status
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;

